import React from "react";
import styles from "./Privacy.module.css";
import { getContactData } from "../utils/extractConfigData";

const Privacy = () => {
  const contactData = getContactData();

  return (
    <section className={styles.privacySection}>
      <div className={styles.container}>
        <h1>Privacyverklaring</h1>
        
        <div className={styles.content}>
          <h2>1. Inleiding</h2>
          <p>
            SchoL!Festival hecht veel waarde aan de bescherming van uw persoonsgegevens en het respecteren 
            van uw privacy. In deze privacyverklaring willen we duidelijke informatie geven over hoe wij 
            omgaan met persoonsgegevens die we verzamelen bij de ticketverkoop voor ons festival.
          </p>
          <p>
            Wij houden ons aan de toepasselijke wet- en regelgeving, waaronder de Algemene Verordening 
            Gegevensbescherming (GDPR/AVG).
          </p>

          <h2>2. Welke gegevens verzamelen wij?</h2>
          <p>Bij de aankoop van tickets verzamelen wij de volgende persoonsgegevens:</p>
          <ul>
            <li>Voor- en achternaam</li>
            <li>E-mailadres</li>
            <li>GSM-nummer (optioneel, voor dringende info)</li>
          </ul>

          <h2>3. Waarom verzamelen wij deze gegevens?</h2>
          <p>
            Wij verzamelen deze gegevens uitsluitend voor de volgende doeleinden:
          </p>
          <ul>
            <li>Het verwerken en bevestigen van uw ticketaankoop</li>
            <li>Het versturen van de tickets naar uw e-mailadres</li>
            <li>Ticketcontrole bij de ingang van het festival</li>
            <li>U te contacteren in geval van wijzigingen of annulering van het evenement</li>
          </ul>

          <h2>4. Hoe lang bewaren wij uw gegevens?</h2>
          <p>
            Wij bewaren uw persoonsgegevens niet langer dan strikt noodzakelijk om de doelen te realiseren 
            waarvoor uw gegevens worden verzameld. We bewaren uw gegevens tot maximaal 3 maanden na afloop 
            van het festival, waarna ze worden verwijderd.
          </p>

          <h2>5. Delen met derden</h2>
          <p>
            Wij verkopen uw gegevens niet aan derden en verstrekken deze uitsluitend als dit nodig is voor 
            de uitvoering van onze overeenkomst met u (bijvoorbeeld aan onze ticketprovider voor het verwerken 
            van de betalingen) of om te voldoen aan een wettelijke verplichting.
          </p>

          <h2>6. Uw rechten</h2>
          <p>U heeft de volgende rechten met betrekking tot uw persoonsgegevens:</p>
          <ul>
            <li>Recht op inzage in uw persoonsgegevens</li>
            <li>Recht op correctie of verwijdering van uw persoonsgegevens</li>
            <li>Recht om bezwaar te maken tegen de verwerking van uw persoonsgegevens</li>
            <li>Recht op overdraagbaarheid van uw gegevens</li>
          </ul>
          <p>
            U kunt een verzoek tot inzage, correctie, verwijdering of overdracht van uw persoonsgegevens 
            sturen naar het e-mailadres dat vermeld staat bij contactgegevens. Om er zeker van te zijn dat 
            het verzoek door u is gedaan, kunnen wij u vragen om u te identificeren.
          </p>

          <h2>7. Contact</h2>
          <p>
            Als u vragen heeft over deze privacyverklaring of over de verwerking van uw persoonsgegevens, 
            kunt u contact met ons opnemen via:
          </p>
          <p className={styles.contact}>
            E-mail: {contactData.email}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy; 